import { put, call } from 'redux-saga/effects';
import {
    getSlotsSuccessAction,
    getSlotsFailureAction,
    getDoctorSlotsSuccessAction,
    getDoctorSlotsFailureAction,
    getSlotsAfterSomeTimeRequestAction,
    getSlotsAfterSomeTimeFailureAction,
    getSlotsAfterSomeTimeSuccessAction
} from '../actions/slotsActions';
import { END_POINTS } from '../../api/endpoints';
import { API } from '../../api/api';

export function* getDoctorSlotsData(action) {
    try {
        const { date, pageNo = 1, pageSize = 10, hospitalId } = action.payload || {};
        const baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;

        const slotResponse = yield call(
            API.get,
            `${baseUrl}${END_POINTS.doctorSlots(date, pageNo, pageSize, hospitalId)}`
        );

        if (!slotResponse.success) {
            throw new Error(slotResponse.message);
        }

        yield put(getSlotsSuccessAction({
            data: slotResponse.data,
            hasNext: slotResponse.meta?.hasNext,
            pageNo
        }));
    } catch (error) {
        yield put(getSlotsFailureAction(error.message));
    }
}

export function* getDoctorSlotsSilentlyData(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;

        let pageNo = 1;
        const pageSize = 10;
        let allSlots = [];
        let hasNext = true;

        while (hasNext) {
            const slotResponse = yield call(
                API.get,
                `${baseUrl}${END_POINTS.doctorSlots(
                    action.payload.date,
                    pageNo,
                    pageSize,
                    action.payload.hospitalId
                )}`
            );

            if (!slotResponse.success) {
                throw new Error(slotResponse.message);
            }

            allSlots = [...allSlots, ...slotResponse.data];
            hasNext = slotResponse.meta?.hasNext;
            pageNo += 1;
        }
        yield put(getSlotsAfterSomeTimeSuccessAction(allSlots));
    } catch (error) {
        yield put(getSlotsAfterSomeTimeFailureAction(error.message));
    }
}

export function* getDoctorSlotsDayWiseData(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        let pageNo = 1;
        const pageSize = 10;
        let allSlots = [];
        let hasNext = true;

        while (hasNext) {
            const slotResponse = yield call(
                API.get,
                `${baseUrl}${END_POINTS.doctorSlots(
                    action.payload.date,
                    pageNo,
                    pageSize,
                    action.payload.hospitalId
                )}`
            );

            if (!slotResponse.success) {
                throw new Error(slotResponse.message);
            }

            allSlots = [...allSlots, ...slotResponse.data];
            hasNext = slotResponse.meta?.hasNext;
            pageNo += 1;
        }
        yield put(getDoctorSlotsSuccessAction(allSlots));
    } catch (error) {
        yield put(getDoctorSlotsFailureAction(error.message));
    }
}

